var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.noIcon)?_c('i',{staticClass:"fas fa-question-circle"}):_vm._e(),_c('div',{staticClass:"tooltip",style:(_vm.large && 'width: 420px')},[_c('span',{staticClass:"tooltip--text"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }